export const ALERTS_OF_VULNERABILITY_ROUTES = {
  ALERTS: '/alertas-de-vulnerabilidade/alertas',
  ALERTS_TYPES: '/alertas-de-vulnerabilidade/tipos-de-alertas',
  ALERT_PROFILE: '/alertas-de-vulnerabilidade/alertas/[alertSlug]',
  ALERTS_VISUALIZATIONS: '/alertas-de-vulnerabilidade/visualizacoes-dos-alertas',
  MONITORING_ACTIONS: '/alertas-de-vulnerabilidade/acoes-de-monitoramento',
  PUBLIC_AGENTS_PERMISSIONS: '/alertas-de-vulnerabilidade/permissoes-dos-agentes-publicos',
  GROUPS_PERMISSIONS: '/alertas-de-vulnerabilidade/permissoes-dos-grupos',
  /* REPORTS */
  GENERAL_REPORT: '/alertas-de-vulnerabilidade/relatorio-geral',
}
